import React from 'react';

import { FacilityProfile } from './section/FacilityProfile';
import {
  CreditAgreement,
  CreditAgreementFullArtifactWipConfigType,
} from 'packages/creditAgreements/ui/types';

/**
 * Deal-profile section of a Backup Servicing (BUS) deal — the facility's asset
 * class and primary balance label, which the portfolio snapshot shows but no
 * tape carries.
 *
 * Prop-compatible with the other artifact bodies so it drops into the shared
 * client WIP editor via its `ArtifactComponent` seam; the BUS Settings hub mounts
 * it as the "Deal Profile" section. Saves round-trip the whole artifact JSON, so
 * editing just this section needs no backend change.
 */
// organizationId is part of the shared artifact-body signature but unused here;
// omitting it keeps the component assignable to the ArtifactComponent type the
// WIP editor injects.
type BusDealProfileArtifactProps = {
  creditAgreementFullArtifact: CreditAgreement.DomainEntity.CreditAgreementFullArtifact;
  wipConfig?: CreditAgreementFullArtifactWipConfigType;
};

export const BusDealProfileArtifact = ({
  creditAgreementFullArtifact,
  wipConfig,
}: BusDealProfileArtifactProps): React.ReactElement => (
  <FacilityProfile
    backupServicingMechanics={
      creditAgreementFullArtifact.backupServicingMechanics
    }
    wipConfig={wipConfig}
  />
);
